<template>
  <main class="invite-page">
    <AppNavBar
      class="invite-page__nav"
      :title="t('invite.title')"
      :border="false"
      :placeholder="false"
      :background-color="
        showNavSolid
          ? 'linear-gradient(90deg, #24150E 0%, #21150F 100%)'
          : 'transparent'
      "
      leftArrowColor="#fff"
      text-color="#ffffff"
    >
      <template #right>
        <button
          type="button"
          class="invite-page__nav-action"
          @click="openRewardDetails"
        >
          <app-image src="@/assets/images/homeImage/reward_icon.png" alt="" />
        </button>
      </template>
    </AppNavBar>

    <section class="invite-hero">
      <app-image
        class="invite-hero__background"
        :src="themeStore.image('img20', inviteHeroBg)"
        alt=""
      />
      <div class="invite-hero__content">
        <button
          type="button"
          class="invite-hero__rules"
          @click="openReferralDocument"
        >
          {{ t("invite.pointsRules") }}
        </button>
        <h1 class="invite-hero__title">{{ t("invite.heroTitle") }}</h1>
        <p class="invite-hero__desc">{{ t("invite.heroDesc") }}</p>
      </div>
      <section ref="pointsCardRef" class="points-card">
        <div ref="pointsCarouselRef" class="points-card__carousel">
          <div
            v-for="card in levelCards"
            :key="card.label"
            class="points-card__item"
          >
            <PointsLevelCard
              :card="card"
              :tag-text="
                card.isPartner ? t('invite.partner') : t('mine.currentLevel')
              "
              :join-text="t('invite.partnerJoinNow')"
              variant="wallet"
              preserve-progress-space
              @join-partner="openPartnerQuestionnaire"
            />
          </div>
        </div>
      </section>
      <div class="invite-hero__claim">
        <div class="invite-hero__claim-label">
          {{ claimableAmountLabel }}
        </div>
        <div class="invite-hero__claim-row">
          <div data-strong>{{ claimableCommission }}</div>
          <van-button
            round
            type="primary"
            class="invite-hero__claim-button"
            :loading="claiming"
            :disabled="!canClaim || claiming"
            @click="claimReward"
          >
            {{ t("invite.pendingClaim") }}
          </van-button>
        </div>
      </div>
    </section>

    <section
      v-if="!isCurrentPartner"
      class="invite-card-bg"
      @click="openCoursePromotion"
    >
      <div class="invite-card-bg__content">
        <div class="invite-card-bg__title">
          {{ t("invite.coursePromotionTitle") }}
        </div>
        <div class="invite-card-bg__desc">
          {{ t("invite.coursePromotionDesc") }}
        </div>
      </div>
      <div class="invite-card-bg-img">
        <app-image :src="themeStore.image('img21')" alt=""></app-image>
      </div>
    </section>

    <!-- <section class="invite-card invite-card--first">
      <div class="card-title">
        <i />
        <h2>{{ t("invite.myExclusiveInvite") }}</h2>
      </div>

      <div class="invite-row">
        <span>{{ t("invite.invitationCodeShort") }}</span>
        <div class="invite-row__value">
          <div class="value">{{ invitationCodeText }}</div>
          <button type="button" @click="copyText(invitationCodeText)">
            <app-image src="@/assets/images/common_copy_icon_gray.png" alt="" />
          </button>
        </div>
      </div>

      <div class="invite-row">
        <span>{{ t("invite.invitationLinkShort") }}</span>
        <div class="invite-row__value invite-row__value--wide">
          <div class="value">{{ shortLink }}</div>
          <button type="button" @click="copyText(invitationLink)">
            <app-image src="@/assets/images/common_copy_icon_gray.png" alt="" />
          </button>
        </div>
      </div>

      <p class="invite-card__desc">
        {{ t("invite.invitationRelationTip") }}
      </p>
    </section> -->

    <section class="invite-card invite-reward-summary">
      <div class="reward-card-head">
        <div class="card-title reward-card-head__title">
          <i />
          <h2>{{ t("invite.commissionDetails") }}</h2>
        </div>
        <button
          type="button"
          class="reward-card-head__more"
          @click="openRewardDetails"
        >
          <span>{{ t("invite.viewFullRecords") }}</span>
          <van-icon name="arrow" />
        </button>
      </div>

      <div class="invite-reward-summary__list">
        <div class="invite-row" @click="openRecommendedUsers">
          <span>{{ t("invite.invitedFriendsTotal") }}</span>
          <div class="invite-row__value">
            <div class="value">
              {{ invitedFriendsTotal }} {{ t("invite.personUnit") }}
            </div>
          </div>
        </div>

        <div class="invite-row">
          <span>{{ t("invite.pendingCommission") }}</span>
          <div class="invite-row__value">
            <div class="value">{{ waitingCommission }} {{ rewardSymbol }}</div>
          </div>
        </div>

        <div class="invite-row invite-row--last">
          <span>{{ t("invite.totalCommission") }}</span>
          <div class="invite-row__value">
            <div class="value">{{ totalCommission }} {{ rewardSymbol }}</div>
          </div>
        </div>
      </div>
    </section>

    <section class="invite-card invite-card--recommender">
      <div class="card-title">
        <i />
        <h2>{{ t("invite.recommender") }}</h2>
      </div>

      <div class="invite-bind">
        <div
          class="invite-bind__field"
          :class="{ 'invite-bind__field--bound': isBound }"
        >
          <van-field
            v-model="parentCode"
            :readonly="isBound"
            :border="false"
            :placeholder="t('invite.enterRecommenderCode')"
          />
          <button
            v-if="!isBound"
            type="button"
            class="invite-bind__scan"
            :aria-label="t('invite.scanRecommenderCode')"
            @click="openScanner"
          >
            <app-image :src="scanCodeIcon" alt="" />
          </button>
        </div>
        <van-button
          :type="isBound ? 'default' : 'primary'"
          class="invite-bind__button"
          :class="{ 'invite-bind__button--bound': isBound }"
          :disabled="isBound"
          @click="bindParent"
        >
          {{ isBound ? t("invite.bound") : t("invite.bind") }}
        </van-button>
      </div>
    </section>

    <section class="invite-card">
      <div class="card-title">
        <i />
        <h2>{{ t("invite.inviteSteps") }}</h2>
      </div>

      <div
        v-for="(item, index) in steps"
        :key="item.text"
        class="step-row"
        :class="{ 'step-row--last': index === steps.length - 1 }"
      >
        <div class="step-row__icon">
          <app-image :src="item.icon" alt="" />
          <b v-if="index !== steps.length - 1" />
        </div>
        <span>{{ item.text }}</span>
      </div>
    </section>

    <div class="invite-bottom">
      <div class="invite-bottom__url-list">
        <div
          class="invite-bottom__url flex"
          @click="copyUrlRow(invitationCodeText)"
        >
          <span class="nowrap">{{ t("invite.invitationCodeShort") }}</span>
          <div class="url">
            <span v-if="isInviteLocked">{{ t("invite.notUnlocked") }}</span>
            <span v-else class="black">
              {{ invitationCodeText }}
            </span>
            <AppSvgIcon v-if="isInviteLocked" :src="lockIcon" size="14" />
            <AppSvgIcon
              v-else
              :src="inviteBottomCopyIcon"
              size="16"
              class="invite-bottom__url-icon"
            />
          </div>
        </div>
        <div
          class="invite-bottom__url"
          @click="copyUrlRow(invitationLink)"
        >
          <span class="label">{{ t("invite.invitationLinkShort") }}</span>
          <div class="url">
            <span v-if="isInviteLocked">{{ t("invite.notUnlocked") }}</span>
            <span v-else class="black">
              {{ shortLink }}
            </span>
            <AppSvgIcon v-if="isInviteLocked" :src="lockIcon" size="14" />
            <AppSvgIcon
              v-else
              :src="inviteBottomCopyIcon"
              size="16"
              class="invite-bottom__url-icon"
            />
          </div>
        </div>
      </div>
      <div class="invite-bottom__button">
        <van-button block round type="primary" @click="handleShareClick">
          {{ t("invite.inviteNow") }}
        </van-button>
      </div>
    </div>

    <van-popup
      v-model:show="showInvitePosterPopup"
      position="center"
      class="invite-poster-popup"
      :class="{ 'invite-poster-popup--compact': isShortViewport }"
      overlay-class="invite-poster-overlay"
      :close-on-click-overlay="false"
    >
      <section ref="invitePosterRef" class="invite-poster">
        <img
          class="invite-poster__art"
          :src="themeStore.image('img8', inviteBgImage)"
          alt=""
          loading="eager"
        />
        <!-- <app-image
          class="invite-poster__logo"
          :src="inviteLogo"
          :alt="themeStore.name"
        /> -->
        <div class="invite-poster-logo">
          <!-- <app-image
            class="logo"
            :src="themeStore.image('img9', inviteLogo)"
            :alt="themeStore.name"
          /> -->
          <img
            class="title"
            :src="themeStore.image('img17', inviteTitle)"
            :alt="themeStore.name"
            loading="eager"
          />
        </div>

        <h2 class="invite-poster__title">
          {{ t("invite.posterTitle") }}
        </h2>

        <div class="invite-poster__code">
          <div class="invite-poster__code-main">
            <div>
              <span>{{ t("invite.invitationCodeShort") }}：</span>
              <div class="invite-poster__code-value">
                {{ invitationCodeText }}
              </div>
            </div>
            <p>{{ t("invite.posterTagline") }}</p>
          </div>
          <div class="invite-poster__qrcode">
            <img v-if="qrUrl" :src="qrUrl" alt="" loading="eager" />
          </div>
        </div>
      </section>
    </van-popup>

    <van-popup
      v-model:show="showSharePopup"
      position="bottom"
      :overlay="false"
      @close="closesPopup"
      class="share-popup"
      :class="{ 'share-popup--compact': isShortViewport }"
    >
      <div class="share-popup__header">
        <span />
        <h3>{{ t("invite.share") }}</h3>
        <button type="button" @click="closeSharePopup">
          <app-image
            class="app-cancel-icon"
            src="@/assets/images/cancel_gray.png"
            alt=""
          />
        </button>
      </div>

      <div class="share-popup__rows">
        <div class="share-popup__row">
          <span>{{ t("invite.invitationCodeShort") }}</span>
          <div>
            <div class="share-popup__value">{{ invitationCodeText }}</div>
            <button type="button" @click="copyText(invitationCodeText)">
              <app-image
                src="@/assets/images/common_copy_icon_gray.png"
                alt=""
              />
            </button>
          </div>
        </div>
        <div class="share-popup__row">
          <span>{{ t("invite.invitationLinkShort") }}</span>
          <div>
            <div class="share-popup__value">{{ shortLink }}</div>
            <button type="button" @click="copyText(invitationLink)">
              <app-image
                src="@/assets/images/common_copy_icon_gray.png"
                alt=""
              />
            </button>
          </div>
        </div>
      </div>

      <div class="share-popup__actions">
        <div class="share-popup__icon" @click="downloadQrCode">
          <span><van-icon :name="arrowDownLogo" /></span>
          {{ t("invite.saveImage") }}
        </div>
        <div class="share-popup__icon" @click="copyText(invitationLink)">
          <span><van-icon :name="copyLogo" /></span>
          {{ t("invite.copyUrl") }}
        </div>
      </div>
    </van-popup>

    <van-popup
      v-model:show="showInviteLockDialog"
      class="invite-kyc-dialog-popup"
      :close-icon="kycInviteCloseIcon"
      closeable
    >
      <section class="invite-kyc-dialog">
        <app-image
          class="invite-kyc-dialog__icon"
          :src="kycInviteIcon"
          alt=""
        />
        <!-- <div class="invite-kyc-dialog__close" @click="closeInviteLockDialog">
          <AppSvgIcon :src="" size="14" />
        </div> -->
        <h2>{{ t("invite.purchaseCardToInvite") }}</h2>
        <p>{{ t("invite.purchaseCardToInviteDesc") }}</p>
        <div class="invite-kyc-dialog__actions">
          <button
            type="button"
            class="invite-kyc-dialog__cancel"
            @click="closeInviteLockDialog"
          >
            {{ t("invite.purchaseCardToInviteLater") }}
          </button>
          <button
            type="button"
            class="invite-kyc-dialog__confirm"
            @click="openCardForInvite"
          >
            {{ t("invite.purchaseCardToInviteNow") }}
          </button>
        </div>
      </section>
    </van-popup>

    <van-popup
      v-model:show="showKycDialog"
      class="kyc-dialog-popup"
      :close-on-click-overlay="false"
    >
      <section class="kyc-dialog">
        <AppSvgIcon
          class="kyc-dialog__icon"
          color="#fff"
          name="kyc_dialog_icon"
          size="50"
        />
        <button type="button" class="kyc-dialog__close" @click="closeKycDialog">
          <app-image
            class="app-cancel-icon"
            src="@/assets/images/cancel_gray.png"
            alt=""
          />
        </button>
        <h2>{{ t("card.kycDialogTitle") }}</h2>
        <p>{{ t("invite.kycPurchaseCardDesc") }}</p>
        <div class="kyc-dialog__actions">
          <button
            type="button"
            class="kyc-dialog__cancel"
            @click="closeKycDialog"
          >
            {{ t("common.cancel") }}
          </button>
          <button
            type="button"
            class="kyc-dialog__confirm"
            @click="confirmKycDialog"
          >
            {{ t("card.kycDialogAction") }}
          </button>
        </div>
      </section>
    </van-popup>
  </main>
</template>

<script setup>
import { computed, nextTick, onMounted, onUnmounted, ref, watch } from "vue";
import QRCode from "qrcode";
import html2canvas from "html2canvas";
import {
  closeToast,
  showConfirmDialog,
  showFailToast,
  showLoadingToast,
  showSuccessToast,
  showToast,
} from "vant";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { userGetUserInfoByAddress } from "@/api/auth";
import { pcCardCreatePre } from "@/api/card";
import { useWalletScanner } from "@/composables/useWalletScanner";
import { copyToClipboard } from "@/utils/clipboard";
import { detectAppType } from "@/utils/device";
import { formatCardTimestamp } from "@/view/card/utils";
import { getRouteState, navigateWithState } from "@/utils/route-state";
import {
  ptBindParent,
  ptInfo,
  refDoc,
  refOverview,
  refRewardClaim,
} from "@/api/wallet";
import { useProfileStore } from "@/stores/profile";
import { useThemeStore } from "@/stores/theme";
import { useInviteRewardStore } from "@/stores/invite-reward";
import { useWebModalStore } from "@/stores/web-modal";
import PointsLevelCard from "@/components/PointsLevelCard.vue";
import stepOneIcon from "@/assets/images/homeImage/invite_icon_one.png";
import stepTwoIcon from "@/assets/images/homeImage/invite_icon_two.png";
import stepThreeIcon from "@/assets/images/homeImage/invite_icon_three.png";
import pointCardTwoIcon from "@/assets/images/settingImage/pointCard_two_icon.png";
import pointCardThreeIcon from "@/assets/images/settingImage/pointCard_three_icon.png";
import pointCardFourIcon from "@/assets/images/settingImage/pointCard_four_icon.png";
import scanCodeIcon from "@/assets/images/common_scancode_icon3.png";
import inviteBottomCopyIcon from "@/assets/images/SVG/icon/copy.svg";
import inviteOpenImage from "@/assets/images/Invite/img_open.png";
import inviteBgImage from "@/assets/images/SVG/invite_bg.png";
import inviteHeroBg from "@/assets/images/Invite/inviteHeroBg.png";
// import inviteLogo from "@/assets/images/Invite/img_logo.svg";
import inviteLogo from "@/assets/images/SVG/logo.png";
import inviteTitle from "@/assets/images/SVG/title.png";
import arrowDownLogo from "@/assets/images/Invite/img_arrow_down.svg";
import copyLogo from "@/assets/images/Invite/img_copy.svg";
import inviteCardBg from "@/assets/images/Invite/banner.png";
import lockIcon from "@/assets/images/SVG/icons/lock.svg";
import kycInviteIcon from "@/assets/images/SVG/kyc_invite_icon.png";
import kycInviteCloseIcon from "@/assets/images/SVG/icons/kyc_invite_close.svg";

const coursePromotionUrl = " https://hk.webx.ai/de7db0";

const { t, locale } = useI18n();
const route = useRoute();
const router = useRouter();
const { openWalletScanner } = useWalletScanner();
const profileStore = useProfileStore();
const themeStore = useThemeStore();
const rewardStore = useInviteRewardStore();
const webModalStore = useWebModalStore();
const pageState = computed(() => getRouteState(route, "wallet-invite", {}));

const inviteOverview = ref({});
const referralDocument = ref({});
const parentCode = ref("");
const userNum = ref("--");
const showSharePopup = ref(false);
const showInvitePosterPopup = ref(false);
const showInviteLockDialog = ref(false);
const showKycDialog = ref(false);
const qrUrl = ref("");
const handledScanValue = ref("");
const showNavSolid = ref(false);
const openingReferralDocument = ref(false);
const openingPartnerQuestionnaire = ref(false);
const claiming = ref(false);
const isShortViewport = ref(false);
const pointsCardRef = ref(null);
const pointsCarouselRef = ref(null);
const invitePosterRef = ref(null);
const invitePosterImage = ref(null);
let invitePosterImagePromise = null;

const invitationCodeText = computed(() =>
  String(inviteOverview.value?.invitationCode || "--"),
);
const isBound = computed(() => Number(inviteOverview.value?.isBind || 0) === 1);
const isInviteLocked = computed(() => {
  const value = inviteOverview.value?.refFlag;
  if (value === true) return false;
  if (value === false) return true;

  const normalized = String(value ?? "")
    .trim()
    .toLowerCase();
  return normalized === "false" || normalized === "0";
});
const rewardPreviewList = computed(() => rewardStore.previewList);
const rewardSymbol = computed(
  () => String(inviteOverview.value?.symbol || "USDT").trim() || "USDT",
);
const claimableAmountLabel = computed(() =>
  t("invite.claimableAmount").replace("USDT", rewardSymbol.value),
);
const invitedFriendsTotal = computed(() =>
  String(inviteOverview.value?.inviteCnt ?? 0),
);
const claimableCommission = computed(
  () => inviteOverview.value?.claimableAmount,
);
const canClaim = computed(() => Number(claimableCommission.value) > 0);
const waitingCommission = computed(() => inviteOverview.value?.waitingAmount);
const totalCommission = computed(() => inviteOverview.value?.totalAmount);
const invitationLink = computed(() => {
  const url = String(themeStore.url?.inviteRegisterUrl || "").trim();
  const code = String(invitationCodeText.value || "").trim();
  return url && code && code !== "--" ? `${url}${code}` : "--";
});
const referralDocumentUrl = computed(() =>
  String(referralDocument.value?.url || "").trim(),
);
const partnerQuestionnaireUrl = computed(() =>
  String(referralDocument.value?.questionnaireUrl || "").trim(),
);
const questionnaireLanguage = computed(() =>
  String(locale.value || profileStore.locale || "zh-CN").replace(/-/g, "_"),
);
const inviteRulesUrl = computed(() => {
  const inviteUrl = String(themeStore.url?.inviteUrl || "")
    .trim()
    .replace(/\/+$/, "");
  return inviteUrl ? `${inviteUrl}/${questionnaireLanguage.value}.html` : "";
});
const shortLink = computed(() => truncateLink(invitationLink.value));
const steps = computed(() => [
  { icon: stepOneIcon, text: t("invite.step1") },
  { icon: stepTwoIcon, text: t("invite.step2") },
  { icon: stepThreeIcon, text: t("invite.step3") },
]);

const levelList = computed(() => {
  const levels = Array.isArray(inviteOverview.value?.levels)
    ? inviteOverview.value.levels
    : [];
  return [...levels].sort(
    (left, right) => Number(left?.level || 0) - Number(right?.level || 0),
  );
});

const currentLevelIndex = computed(() => {
  const index = levelList.value.findIndex(
    (level) => Number(level?.current) === 1,
  );
  return index >= 0 ? index : 0;
});
const isCurrentPartner = computed(
  () => Number(levelList.value[currentLevelIndex.value]?.partner) === 1,
);

function appendQuestionnaireParams(url) {
  const value = String(url || "").trim();
  if (!value) {
    return "";
  }

  const params = [
    ["lang", questionnaireLanguage.value],
    ["userId", userNum.value],
  ]
    .filter(([, paramValue]) => paramValue && paramValue !== "--")
    .map(
      ([key, paramValue]) => `${key}=${encodeURIComponent(String(paramValue))}`,
    )
    .join("&");
  if (!params) {
    return value;
  }

  const separator = value.includes("?")
    ? value.endsWith("?") || value.endsWith("&")
      ? ""
      : "&"
    : "?";
  return `${value}${separator}${params}`;
}

function formatRewardAmount(value) {
  const amount = Number(value);
  return Number.isFinite(amount) ? amount : "0.00";
}

function getLevelProgressValue(count, minCount) {
  const requiredCount = Number(minCount);
  if (!Number.isFinite(requiredCount) || requiredCount <= 0) {
    return 100;
  }
  return Math.min(100, Math.max(0, (Number(count || 0) / requiredCount) * 100));
}

function getLevelHintText(count, minCount = 0) {
  const requiredCount = Number(minCount);
  if (!Number.isFinite(requiredCount) || requiredCount < 0) {
    return String(count || 0);
  }
  return `${Math.min(Number(count || 0), requiredCount)}/${requiredCount}`;
}

const levelCards = computed(() => {
  const invitedCount = Number(inviteOverview.value?.refCnt || 0);
  const styles = [
    {
      svgIcon: "point-card-one",
      primaryColor: "var(--wp-color-brand-1)",
      descColor: "var(--wp-color-brand-1)",
      barBg: "#FBEBDD",
      barColor: "var(--wp-color-brand-1)",
      tagColor: "var(--wp-color-brand-1)",
      tagTextColor: "#ffffff",
      cardStyle: {
        background: "linear-gradient(180deg, #FBEBDD 0%, #ffffff 100%)",
        boxShadow: "0 2px 3px #FBEDE0",
      },
    },
    {
      icon: pointCardTwoIcon,
      primaryColor: "#234796",
      descColor: "#3e67c0",
      barBg: "#b3dcff",
      barColor: "#234796",
      tagColor: "#234796",
      tagTextColor: "#ffffff",
      cardStyle: {
        background: "linear-gradient(180deg, #aed9ff 0%, #ffffff 100%)",
        boxShadow: "0 2px 3px rgba(223, 240, 255, 1)",
      },
    },
    {
      icon: pointCardThreeIcon,
      primaryColor: "#b15921",
      descColor: "#e08449",
      barBg: "#f9e5c3",
      barColor: "#b15921",
      tagColor: "#b15921",
      tagTextColor: "#ffffff",
      cardStyle: {
        background: "linear-gradient(180deg, #fce8c3 0%, #ffffff 100%)",
        boxShadow: "0 2px 3px rgba(246, 198, 113, 0.20)",
      },
    },
  ];
  const partnerStyle = {
    icon: pointCardFourIcon,
    primaryColor: "#ffeaa3",
    descColor: "#ffeaa3",
    barBg: "#8d8c8c",
    barColor: "#ffeaa3",
    tagColor: "#ffeaa3",
    tagTextColor: "#414141",
    cardStyle: {
      background: "#4e4d4d",
      boxShadow: "none",
    },
  };

  return levelList.value.map((level, index) => {
    const isPartner = Number(level?.partner) === 1;
    const isLast = index === levelList.value.length - 1;
    const style = isPartner ? partnerStyle : styles[index % styles.length];
    const minCount = Number(level?.minCnt || 0);
    const cardLevel = Number(level?.level || index + 1);

    return {
      ...style,
      label: String(level?.name || `LV.${level?.level || index + 1}`),
      level: cardLevel,
      isCurrent: Number(level?.current) === 1,
      isPartner,
      isShowBar: minCount > 0,
      progress: getLevelProgressValue(invitedCount, minCount),
      hint: getLevelHintText(invitedCount, minCount),
      monthRatePercent: String(level?.monthRatePercent || "0%"),
      metrics: [
        {
          label: t("invite.purchaseCommission"),
          icon: "info-o",
          action: "purchaseCommission",
          value: String(level?.openRatePercent || "0%"),
        },
        {
          label: t("invite.consumptionCommission"),
          icon: "info-o",
          action: "consumptionCommission",
          value: String(level?.directRatePercent || "0%"),
        },
        {
          label: t("invite.invitationTotal"),
          isCount: true,
          click: openRecommendedUsers,
          value: String(invitedCount),
        },
      ],
    };
  });
});

function truncateLink(value) {
  const text = String(value || "").trim();
  if (!text || text === "--") {
    return "--";
  }
  if (text.length <= 10) {
    return text;
  }
  return `${text.slice(0, 5)}...${text.slice(-5)}`;
}

async function copyText(text) {
  const value = String(text || "").trim();
  if (!value || value === "--") {
    return;
  }
  const copied = await copyToClipboard(value);
  if (copied) {
    showSuccessToast(t("wallet.copySuccess"));
    return;
  }
  showFailToast(t("wallet.copyFailed"));
}

function copyUrlRow(text) {
  if (isInviteLocked.value) {
    return;
  }
  void copyText(text);
}

function openScanner() {
  openWalletScanner({
    back: "/wallet/invite",
    stateNamespace: "wallet-invite",
    statePayload: { ...pageState.value },
  });
}

function openRewardDetails() {
  navigateWithState(router, "/wallet/invite/reward", {
    namespace: "wallet-invite-reward",
    payload: {
      overview: inviteOverview.value,
    },
  });
}

function openRecommendedUsers() {
  router.push("/wallet/invite/recommended-users");
}

function openCoursePromotion() {
  const url = `${themeStore.url.shareInviteUrl}${questionnaireLanguage.value}.html`;
  webModalStore.open({
    url,
    title: t("invite.referralStepsTitle"),
    navBackgroundColor: "#F2F2F2",
  });
}

async function openReferralDocument() {
  if (openingReferralDocument.value) {
    return;
  }

  openingReferralDocument.value = true;
  try {
    const url = inviteRulesUrl.value;
    if (!url) {
      showFailToast(t("common.retryLater"));
      return;
    }

    webModalStore.open({
      url,
      title: t("invite.pointsRules"),
      navBackgroundColor: "#fff",
    });
  } catch (error) {
    showFailToast(error?.message || t("common.retryLater"));
  } finally {
    openingReferralDocument.value = false;
  }
}

async function openPartnerQuestionnaire() {
  if (openingPartnerQuestionnaire.value) {
    return;
  }

  openingPartnerQuestionnaire.value = true;
  try {
    if (!partnerQuestionnaireUrl.value) {
      await loadReferralDocument(true);
    }

    if (!userNum.value || userNum.value === "--") {
      const userInfo = await ptInfo(
        { address: profileStore.platformAddress || null },
        { meta: { showLoading: false } },
      );
      userNum.value = String(userInfo?.userNum ?? "");
    }

    const url = appendQuestionnaireParams(partnerQuestionnaireUrl.value);
    if (!url) {
      showFailToast(t("common.retryLater"));
      return;
    }

    webModalStore.open({
      url,
      title: t("invite.partnerJoinNow"),
      navBackgroundColor: "#fff",
    });
  } catch (error) {
    showFailToast(error?.message || t("common.retryLater"));
  } finally {
    openingPartnerQuestionnaire.value = false;
  }
}

async function loadReferralDocument(showLoading = false) {
  const address = profileStore.platformAddress || null;
  if (!address) {
    referralDocument.value = {};
    return "";
  }

  const result = await refDoc(
    {
      address,
      lang: locale.value || profileStore.locale || "zh-CN",
    },
    { meta: { showLoading } },
  );
  referralDocument.value = result || {};
  return referralDocumentUrl.value;
}

async function claimReward() {
  if (!canClaim.value || claiming.value) {
    return;
  }

  const address = profileStore.platformAddress || null;
  const coinId = inviteOverview.value?.coinId;
  const lang = locale.value || profileStore.locale || "zh-CN";
  if (!address || coinId === null || coinId === undefined || coinId === "") {
    showToast({
      message: t("common.retryLater"),
      icon: "close",
      wordBreak: "normal",
    });
    return;
  }

  claiming.value = true;
  try {
    await refRewardClaim(
      { address, coinId, lang },
      { meta: { showLoading: false } },
    );

    try {
      inviteOverview.value =
        (await refOverview(
          { address, lang },
          { meta: { showLoading: false } },
        )) || {};
    } catch (_) {
      // The claim succeeded; the next page refresh will reload the overview.
    }

    showToast({
      message: t("invite.claimSuccess"),
      icon: "success",
      wordBreak: "normal",
    });
  } catch (_) {
    // API errors are displayed by the shared HTTP interceptor with showToast.
  } finally {
    claiming.value = false;
  }
}

async function handleShareClick() {
  const address = profileStore.platformAddress;
  if (!address) {
    router.replace("/login");
    return;
  }

  showLoadingToast({
    message: t("common.loading"),
    forbidClick: true,
    duration: 0,
  });
  try {
    const result = await pcCardCreatePre(
      { address },
      { meta: { showLoading: false } },
    );
    if (Number(result?.holderStatus || 0) === 3) {
      if (isInviteLocked.value) {
        showInviteLockDialog.value = true;
        return;
      }
      showShare();
      return;
    }
    showKycDialog.value = true;
  } catch (error) {
    showFailToast(error?.message || error?.msg || t("common.retryLater"));
  } finally {
    closeToast();
  }
}

function closeInviteLockDialog() {
  showInviteLockDialog.value = false;
}

function openCardForInvite() {
  closeInviteLockDialog();
  navigateWithState(router, "/home/card");
}

function closeKycDialog() {
  showKycDialog.value = false;
}

function confirmKycDialog() {
  closeKycDialog();
  router.push("/card/kyc");
}

function showShare() {
  syncPopupViewport();
  showInvitePosterPopup.value = true;
  showSharePopup.value = true;
  invitePosterImage.value = null;
  invitePosterImagePromise = null;
  void nextTick()
    .then(() => prepareInvitePosterImage())
    .catch(() => {});
}

function syncPopupViewport() {
  const viewportHeight = Number(
    window.visualViewport?.height || window.innerHeight || 0,
  );
  isShortViewport.value = viewportHeight > 0 && viewportHeight <= 800;
}

const closesPopup = () => {
  showInvitePosterPopup.value = false;
  showSharePopup.value = false;
};

function closeSharePopup() {
  showSharePopup.value = false;
}

async function parseInvitationCodeFromScan(rawValue) {
  const value = String(rawValue || "").trim();
  if (!value) {
    return "";
  }
  if (value.includes("r=")) {
    const part = value.split("r=")[1] || "";
    return (part.split("&")[0] || "").trim();
  }
  if (value.includes("&friend")) {
    const targetAddress = (value.split("&friend")[0] || "").trim();
    if (!targetAddress) {
      return "";
    }
    const result = await userGetUserInfoByAddress({
      address: targetAddress,
      targetAddress,
    });
    return String(result?.invitationCode || "").trim();
  }
  return (value.split("&")[0] || "").trim();
}

async function bindParent() {
  const code = String(parentCode.value || "").trim();
  if (!code || isBound.value) {
    return;
  }

  showLoadingToast({
    message: t("common.submitting"),
    forbidClick: true,
    duration: 0,
  });

  try {
    await ptBindParent({
      address: profileStore.platformAddress || null,
      invitationCode: code,
    });
    await loadPageData();
  } catch (error) {
    showFailToast(error?.message || t("common.retryLater"));
  } finally {
    closeToast();
  }
}

async function loadPageData() {
  const address = profileStore.platformAddress || null;
  if (!address) {
    inviteOverview.value = {};
    referralDocument.value = {};
    parentCode.value = "";
    userNum.value = "--";
    rewardStore.reset();
    return;
  }

  try {
    const userInfo = await ptInfo(
      { address },
      { meta: { showLoading: false } },
    );
    userNum.value = String(userInfo?.userNum ?? "");
  } catch (_) {
    userNum.value = "";
  }

  try {
    inviteOverview.value =
      (await refOverview({
        address,
        lang: locale.value || profileStore.locale || "zh-CN",
      })) || {};
    if (Number(inviteOverview.value?.isBind || 0) === 1) {
      parentCode.value = String(
        inviteOverview.value?.parentInvitationCode || "",
      );
    }
  } catch (error) {
    inviteOverview.value = {};
    parentCode.value = "";
    showFailToast(error?.message || t("common.retryLater"));
  }

  try {
    await rewardStore.fetchNext({
      address,
      reset: true,
    });
  } catch (error) {
    rewardStore.reset();
  }
}

function waitForPosterImages(poster) {
  return Promise.all(
    Array.from(poster.querySelectorAll("img")).map((image) =>
      image.complete
        ? Promise.resolve()
        : new Promise((resolve) => {
            image.addEventListener("load", resolve, { once: true });
            image.addEventListener("error", resolve, { once: true });
          }),
    ),
  );
}

function canvasToPngBlob(canvas) {
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) {
        resolve(blob);
        return;
      }
      reject(new Error("Unable to create poster image"));
    }, "image/png");
  });
}

async function createInvitePosterImage() {
  const poster = invitePosterRef.value;
  if (!poster || !qrUrl.value) {
    return null;
  }

  await nextTick();
  await waitForPosterImages(poster);

  const { width, height } = poster.getBoundingClientRect();
  const canvas = await html2canvas(poster, {
    allowTaint: false,
    backgroundColor: "#edf5ff",
    width: Math.ceil(width),
    height: Math.ceil(height),
    imageTimeout: 15000,
    logging: false,
    scale: 2,
    useCORS: true,
  });
  return canvasToPngBlob(canvas);
}

function prepareInvitePosterImage() {
  if (!invitePosterImagePromise) {
    invitePosterImagePromise = createInvitePosterImage()
      .then((image) => {
        invitePosterImage.value = image;
        return image;
      })
      .catch((error) => {
        invitePosterImagePromise = null;
        throw error;
      });
  }
  return invitePosterImagePromise;
}

function downloadPosterImage(image, filename) {
  const objectUrl = URL.createObjectURL(image);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = filename;
  link.style.display = "none";
  document.body.append(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(objectUrl), 60_000);
  return true;
}

async function savePosterImage(image, filename) {
  const supportsFileShare =
    detectAppType() === "ios" &&
    typeof File === "function" &&
    typeof navigator.share === "function";

  if (supportsFileShare) {
    const file = new File([image], filename, { type: "image/png" });
    const shareData = { files: [file], title: filename };
    if (
      typeof navigator.canShare !== "function" ||
      navigator.canShare(shareData)
    ) {
      try {
        await navigator.share(shareData);
        return true;
      } catch (error) {
        if (error?.name === "AbortError") {
          return null;
        }
      }
    }
  }

  return downloadPosterImage(image, filename);
}

async function downloadQrCode() {
  const filename = `invite-${invitationCodeText.value || "poster"}.png`;
  const preparedImage = invitePosterImage.value;
  const hasPendingImages = Array.from(
    invitePosterRef.value?.querySelectorAll("img") || [],
  ).some((image) => !image.complete && image.naturalWidth === 0);

  if (hasPendingImages) {
    showLoadingToast({
      message: t("common.loading"),
      forbidClick: true,
      duration: 0,
    });
  }
  let loadingToastShown = hasPendingImages;

  try {
    const image = preparedImage || (await prepareInvitePosterImage());
    if (!image) {
      throw new Error("Poster image is unavailable");
    }

    if (loadingToastShown) {
      closeToast();
      loadingToastShown = false;
    }

    const saved = await savePosterImage(image, filename);
    if (saved === true) {
      showSuccessToast(t("wallet.saveSuccess"));
    } else if (saved === false) {
      showFailToast(t("wallet.saveFailed"));
    }
  } catch (error) {
    if (loadingToastShown) {
      closeToast();
      loadingToastShown = false;
    }
    showFailToast(t("wallet.saveFailed"));
  } finally {
    if (loadingToastShown) {
      closeToast();
    }
  }
}

function formatRewardTime(timestamp) {
  return formatCardTimestamp(timestamp);
}

function syncNavBarState() {
  const scrollTop =
    window.scrollY ||
    document.documentElement.scrollTop ||
    document.body.scrollTop ||
    0;
  showNavSolid.value = scrollTop > 0;
}

function scrollPointsToLevel(index = 0) {
  const container = pointsCarouselRef.value;
  const children = container?.children || [];
  const target = children[index];
  if (!container || !target) {
    return;
  }

  const leftInset =
    Number.parseFloat(window.getComputedStyle(container).paddingLeft) || 0;

  container.scrollTo({
    left: Math.max(0, target.offsetLeft - leftInset),
    behavior: "auto",
  });
}

function handlePointsResize() {
  syncPopupViewport();
  scrollPointsToLevel(currentLevelIndex.value);
}

watch(
  () => pageState.value.scanResult,
  async (value) => {
    const rawValue = String(value || "").trim();
    if (!rawValue || rawValue === handledScanValue.value || isBound.value) {
      return;
    }
    handledScanValue.value = rawValue;
    navigateWithState(router, route.path, {
      namespace: "wallet-invite",
      replace: true,
      payload: {
        ...pageState.value,
        scanResult: "",
      },
    });
    const code = await parseInvitationCodeFromScan(rawValue);
    if (!code || isBound.value) {
      return;
    }
    parentCode.value = code;
    await bindParent();
  },
  { immediate: true },
);

watch(
  invitationLink,
  async (value) => {
    if (!value || value === "--") {
      qrUrl.value = "";
      return;
    }
    try {
      qrUrl.value = await QRCode.toDataURL(value, {
        margin: 1,
        width: 220,
      });
    } catch (error) {
      qrUrl.value = "";
    }
  },
  { immediate: true },
);

watch(
  currentLevelIndex,
  async (value) => {
    await nextTick();
    scrollPointsToLevel(value);
  },
  { immediate: true },
);

onMounted(() => {
  loadPageData();
  loadReferralDocument().catch(() => {
    referralDocument.value = {};
  });
  syncPopupViewport();
  syncNavBarState();
  window.addEventListener("scroll", syncNavBarState, { passive: true });
  window.addEventListener("resize", handlePointsResize, { passive: true });
  window.visualViewport?.addEventListener("resize", syncPopupViewport, {
    passive: true,
  });
});

onUnmounted(() => {
  window.removeEventListener("scroll", syncNavBarState);
  window.removeEventListener("resize", handlePointsResize);
  window.visualViewport?.removeEventListener("resize", syncPopupViewport);
});
</script>

<style scoped lang="scss">
.invite-page {
  min-height: var(--app-viewport-height);
  padding-bottom: calc(124px + env(safe-area-inset-bottom));
  background: #f7f8fa;
  overflow-x: hidden;
}

:deep(.invite-page__nav.van-nav-bar) {
  z-index: 10;
  transition: background-color 0.2s ease;
}

.invite-page__nav-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  background: transparent;

  .app-image {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }
}

.invite-hero {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 450px;
  padding: calc(
      var(--van-nav-bar-height, 46px) + env(safe-area-inset-top) + 26px
    )
    0 18px;
  overflow: hidden;
  background: #fff;
}

.invite-hero__background {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 0;
  display: block;
  width: 100%;
  height: auto;
  object-fit: fill;
}

.invite-hero__content {
  position: relative;
  z-index: 1;
  max-width: 210px;
  min-height: 154px;
  margin: 0 16px 20px;
}

.invite-hero__rules {
  padding: 0;
  border: 0;
  border-bottom: 1px solid #fce26e;
  background: transparent;
  color: #fce26e;
  font-size: 14px;
  line-height: 20px;
}

.invite-hero__title {
  margin: 20px 0 5px;
  color: #ffffff;
  font-size: 22px;
  line-height: 31px;
  font-weight: 700;

  .price {
    color: #f7dd1a;
    margin-right: 10px;
  }
}

.invite-hero__desc {
  margin: 0;
  color: var(--wp-color-brand-2);
  font-size: 14px;
  line-height: 20px;
}

.invite-hero__claim {
  position: relative;
  z-index: 1;
  min-height: 52px;
  margin: 0 14px;
  color: #999999;
}

.invite-hero__claim-label {
  font-size: 13px;
  line-height: 22px;
}
.van-button--disabled {
  background: #f4f5f6 !important;
  color: #999 !important;
  font-weight: 500 !important;
}

.invite-hero__claim-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 2px;

  [data-strong] {
    font-size: 20px;
  }

  .invite-hero__claim-button {
    position: absolute;
    top: 46%;
    right: 0;
    display: inline-flex;
    align-items: center;
    height: 32px;
    justify-content: center;
    padding: 6px 22px;
    border-radius: 24px;
    border: 0;
    font-size: 14px;
    text-align: center;
    transform: translateY(-50%);
  }
}

.invite-card-bg {
  position: relative;
  z-index: 0;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  min-height: 0;
  margin: 12px 0px 0;
  padding: 0 30px;
  overflow: hidden;
  border-radius: 14px;
  aspect-ratio: 1920 / 512;
  isolation: isolate;

  &-img {
    position: absolute;
    inset: 0;
    z-index: -1;

    .app-image {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.invite-card-bg__content {
  position: relative;
  z-index: 0;
  max-width: 250px;
}

.invite-card-bg__title {
  color: #ffffff;
  font-size: 22px;
  font-weight: 700;
  line-height: 30px;
}

.invite-card-bg__desc {
  margin-top: 2px;
  color: var(--wp-color-brand-2);
  font-size: 13px;
  line-height: 18px;
}

@media (max-width: 360px) {
  .invite-card-bg {
    padding-right: 20px;
    padding-left: 20px;
  }

  .invite-card-bg__content {
    max-width: 210px;
  }

  .invite-card-bg__title {
    font-size: 19px;
    line-height: 26px;
  }

  .invite-card-bg__desc {
    font-size: 12px;
    line-height: 17px;
  }
}

.invite-card {
  margin: 10px 14px 0;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
}

.points-card {
  position: relative;
  flex-shrink: 0;
  box-sizing: border-box;
  z-index: 1;
  overflow: hidden;
}

.points-card__carousel {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  overflow-y: hidden;
  padding-right: 16px;
  padding-left: 14px;
  padding-bottom: 0px;
  scroll-padding-left: 14px;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.points-card__item {
  flex: 0 0 calc(100% - 0px);
  width: calc(100% - 16px);
  padding-bottom: 6px;
  box-sizing: border-box;
  scroll-snap-align: start;
}

.points-card__desc-wrap {
  position: relative;
  min-height: 40px;
}

.points-card__desc {
  margin: 18px 42px 14px 0;
  color: #48486c;
  font-size: 14px;
  line-height: 20px;
}

.points-card--lv2 .points-card__desc {
  color: #3d4f73;
}

.points-card--lv3 .points-card__desc {
  color: #6b5a44;
}

.points-card--lv4 .points-card__desc {
  color: rgba(255, 234, 163, 0.88);
}

.points-card__icon {
  position: absolute;
  right: 0;
  top: 8px;
  width: 23px;
  height: 23px;
  object-fit: contain;
}

.points-card__bar {
  height: 4px;
  border-radius: 999px;
  background: #cfdcff;
  overflow: hidden;

  i {
    display: block;
    height: 100%;
    border-radius: 999px;
    background: var(--wp-color-brand-1);
  }
}

.points-card--lv2 .points-card__bar {
  background: #d7ebff;

  i {
    background: #234796;
  }
}

.points-card--lv3 .points-card__bar {
  background: #f5dfba;

  i {
    background: #b15921;
  }
}

.points-card--lv4 .points-card__bar {
  background: rgba(255, 234, 163, 0.18);

  i {
    background: #ffeaa3;
  }
}

.points-card__foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;

  span {
    color: #999999;
    font-size: 12px;
  }

  button {
    padding: 0;
    border: 0;
    background: transparent;
    color: var(--wp-color-brand-1);
    font-size: 12px;
  }
}

.points-card--lv4 .points-card__foot span {
  color: rgba(255, 234, 163, 0.72);
}

.points-card--lv2 .points-card__foot button,
.points-card--lv3 .points-card__foot button {
  color: currentColor;
}

.points-card--lv4 .points-card__foot button {
  color: #ffeaa3;
}

.invite-card {
  box-sizing: border-box;
  width: 100%;
  padding: 18px 16px;
  margin: 10px auto 12px;
}

.invite-card--first {
  margin-top: 12px;
}

.invite-card__desc {
  margin: 0;
  color: #666666;
  font-size: 12px;
  line-height: 22px;
}

.card-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;

  i {
    width: 4px;
    height: 18px;
    border-radius: 999px;
    background: var(--wp-color-theme);
  }

  h2 {
    margin: 0;
    color: #000000;
    font-size: 16px;
    line-height: 22px;
    font-weight: 700;
  }
}

.invite-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 52px;
  margin-bottom: 12px;
  padding: 0 12px;
  border-radius: 10px;
  background: #f4f5f6;
  gap: 12px;
  font-size: 14px;
  > span {
    flex: 0 0 96px;
    color: #333333;

    white-space: nowrap;
  }
}

.invite-row--last {
  margin-bottom: 0;
}

.invite-row__value {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1;
  min-width: 0;
  gap: 5px;

  .value {
    overflow: hidden;
    color: #000;
    font-size: 16px;
    line-height: 22px;
    text-overflow: ellipsis;
    white-space: nowrap;
    letter-spacing: 0.5px;
    font-weight: 600;
  }

  button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: 0;
    background: transparent;
  }

  .app-image {
    width: 18px;
    height: 18px;
  }
}

.invite-row__value--wide [data-strong] {
  max-width: 182px;
}

.invite-row__icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;

  .app-image {
    width: 20px;
    height: 20px;
  }
}

.invite-bind {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.invite-bind__field {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  padding-left: 12px;
  border-radius: 10px;
  background: #f4f5f6;

  > span {
    flex: 0 0 auto;
    color: #333333;
    font-size: 14px;
    white-space: nowrap;
  }

  :deep(.van-cell) {
    flex: 1;
    padding: 0 0 0 10px;
    background: transparent;
  }

  :deep(.van-field__control) {
    height: 44px;
    // color: #666;
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 0.5px;
  }
}

.invite-bind__field--bound {
  :deep(.van-field__control) {
    font-size: 16px;
    letter-spacing: 1px;
  }
}

.invite-bind__scan {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 40px;
  width: 40px;
  height: 44px;
  padding: 0;
  border: 0;
  background: transparent;
  position: relative;

  .app-image {
    width: 20px;
    height: 20px;
  }
}

.invite-bind__button {
  flex: 0 0 84px;
  --van-button-border-radius: 10px;
  --van-button-primary-border-color: var(--wp-color-button-2);
  --van-button-primary-background: var(--wp-color-button-2);
  --van-button-primary-color: var(--wp-color-brand-1);
  border-radius: 12px;

  :deep(.van-button) {
    font-size: 16px;
    font-weight: 500;
    // border-radius: 16px;
  }

  :deep(.van-button--disabled.van-button--primary) {
    opacity: 1;
    border-color: var(--wp-color-button-2);
    background: #f4f5f6;
    color: #a9c1ff;
  }
}

.invite-bind__button--bound {
  --van-button-default-border-color: #f4f5f6;
  // --van-button-default-background: #f4f5f6;
  // --van-button-default-color: #999999;
  // background: #f4f5f6 !important;
  // color: #999 !important;
  font-weight: 500;

  :deep(.van-button) {
    border-color: #f4f5f6;
    background: #f4f5f6;
    color: #999999;
    border-radius: 16px;
  }

  :deep(.van-button--default) {
    border-color: #f4f5f6;
    background: #f4f5f6;
    color: #999999;
  }
}

.steps-card {
  // padding-bottom: 6px;
}

.reward-card-head {
  display: flex;
  align-items: center;
  // font-size: 16px;
  justify-content: space-between;
}

.reward-card-head__title {
  margin-bottom: 0;
}

.reward-card-head__more {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--wp-color-theme);
  font-size: 14px;

  .app-image {
    width: 10px;
    height: 10px;
    object-fit: contain;
    filter: brightness(0) saturate(100%) invert(33%) sepia(94%) saturate(4438%)
      hue-rotate(220deg) brightness(101%) contrast(101%);
  }
}

.reward-preview__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 0;
  border-bottom: 1px solid #f4f5f6;

  &:last-child {
    padding-bottom: 0;
    border-bottom: 0;
  }

  [data-strong],
  span {
    display: block;
  }

  > div:first-child [data-strong] {
    color: #333;
    font-size: 16px;
    line-height: 22px;
    font-weight: 500;
  }

  > div:first-child span {
    margin-top: 4px;
    color: #999;
    font-size: 14px;
    line-height: 20px;
  }
}

.reward-preview-list {
  margin-top: 14px;
}

.reward-preview__amount {
  text-align: right;

  [data-strong] {
    color: var(--wp-color-theme);
    font-size: 16px;
    line-height: 22px;
    font-weight: 700;
  }

  span {
    margin-top: 4px;
    color: #999;
    font-size: 14px;
    line-height: 20px;
  }
}

.reward-preview--empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0 0;
  color: #999;

  .app-image {
    width: 160px;
  }
}

.invite-reward-summary__list {
  margin-top: 14px;
}

.step-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 4px;

  span {
    flex: 1;
    padding-top: 2px;
    color: #333333;
    font-size: 14px;
    line-height: 20px;
  }
}

.step-row--last {
  margin-bottom: 0;
}

.step-row__icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 0 0 20px;

  .app-image {
    width: 20px;
    height: 20px;
  }

  b {
    width: 1px;
    height: 30px;
    margin: 6px 0 2px;
    border-left: 1px dashed var(--wp-color-theme);
  }
}

.invite-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 10px 14px calc(20px + env(safe-area-inset-bottom));
  background: #fff;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.08);
  font-weight: bold;
  font-size: 16px;
  .flex {
    flex: 0.8;
  }
  &__url {
    flex: 1.2;
    align-items: center;
    gap: 8px;
    background: var(--wp-color-card-1);
    padding: 15px 12px;
    display: flex;
    flex-wrap: nowrap;
    cursor: pointer;
    font-size: 12px;
    color: #666;
    border-radius: 8px;
    .url {
      display: flex;
      gap: 4px;
      color: #999;
    }
    .nowrap {
      // min-width: 47px;
      white-space: nowrap;
    }
  }
  &__url-icon {
    flex: 0 0 16px;
    width: 16px;
    height: 16px;
  }
  &__url-list {
    display: flex;
    gap: 4px;
    margin-bottom: 10px;

    .label {
      flex: 1;
      // white-space: nowrap;
    }
    .black {
      color: #000;
    }
  }
}

:global(.invite-poster-popup.van-popup--center) {
  top: calc(env(safe-area-inset-top) + 16%) !important;
  left: var(--app-shell-left) !important;
  right: calc(
    100vw - var(--app-shell-left) - var(--app-shell-width)
  ) !important;
  width: min(calc(var(--app-shell-width) - 32px), 290px) !important;
  margin: 0 auto !important;
  overflow: hidden;
  border-radius: 16px;
  background: #edf5ff;
  transform: none !important;
}

:global(.invite-poster-overlay) {
  width: var(--app-shell-width);
  max-width: 100vw;
  left: var(--app-shell-left);
  right: auto;
}

.invite-poster {
  position: relative;
  width: 100%;
  height: 340px;
  overflow: hidden;
  background: #edf5ff;
  &-logo {
    position: absolute;
    top: 18px;
    left: 16px;
    display: flex;
    align-items: center;
    gap: 6px;
    // .logo {
    //   width: 25px;
    //   height: 20px;
    //   object-fit: contain;
    // }
    .title {
      margin-top: 5px;
      width: 134px;
      height: 26px;
      object-fit: contain;
    }
  }
}

.invite-poster__art {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.invite-poster__logo {
  position: absolute;
  top: 18px;
  left: 16px;
  // width: 100px;
  // height: auto;
}

.invite-poster__title {
  position: absolute;
  top: 68px;
  right: 12px;
  left: 12px;
  margin: 0;
  color: #fff;
  font-size: 22px;
  font-weight: 700;
  line-height: 30px;
  text-align: center;

  > span,
  > div {
    display: block;
  }

  > div {
    display: flex;
    align-items: baseline;
    justify-content: center;
    gap: 4px;
  }

  b {
    color: var(--wp-color-theme);
    font-size: 20px;
    font-weight: 700;
  }
}

.invite-poster__code {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  min-height: 82px;
  padding: 10px 14px;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.95);
}

.invite-poster__code-main {
  flex: 1;
  min-width: 0;

  > div:first-child {
    display: flex;
    align-items: baseline;
    min-width: 0;
    color: #000000;
    font-size: 14px;

    > span {
      flex: 0 0 auto;
      white-space: nowrap;
    }
  }

  p {
    margin: 4px 0 0;
    color: #999999;
    font-size: 12px;
  }
}

.invite-poster__code-value {
  flex: 1 1 auto;
  min-width: 0;
  // overflow: hidden;
  color: #000000;
  font-size: 15px;
  font-weight: 700;
  // text-overflow: ellipsis;
  // white-space: nowrap;
}

.invite-poster__qrcode {
  display: flex;
  flex: 0 0 58px;
  align-items: center;
  justify-content: center;
  width: 58px;
  height: 58px;
  margin-left: 8px;
  padding: 3px;
  border-radius: 6px;
  background: #ffffff;
  box-shadow: 0 0 0 2px #edf3ff;
  box-sizing: border-box;

  img {
    width: 100%;
    height: 100%;
  }
}

:global(.share-popup.van-popup--bottom) {
  width: var(--app-shell-width);
  max-width: 100vw;
  left: var(--app-shell-left);
  right: auto;
  overflow: hidden;
  border-radius: 24px 24px 0 0;
  background: #ffffff;
}

.share-popup {
  padding-bottom: calc(18px + env(safe-area-inset-bottom));
  background: #ffffff;
}

.share-popup__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 19px 24px 30px;

  > span,
  button {
    width: 24px;
    height: 24px;
  }

  h3 {
    margin: 0;
    color: #111111;
    font-size: 20px;
    font-weight: 500;
  }

  button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: 0;
    background: transparent;
  }

  .app-image {
    width: 22px;
    height: 22px;
  }
}

.share-popup__rows {
  display: grid;
  gap: 12px;
  padding: 0 22px;
}

.share-popup__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px 17px;
  border-radius: 12px;
  border: 1px solid #f4f5f6;

  > span {
    color: #666666;
    font-size: 16px;
  }

  > div {
    display: flex;
    align-items: center;
    min-width: 0;
    margin-left: 12px;
  }

  button {
    display: inline-flex;
    flex: 0 0 22px;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    margin-left: 8px;
    padding: 0;
    border: 0;
    background: transparent;
  }

  .app-image {
    width: 22px;
    height: 22px;
  }
}

.share-popup__value {
  overflow: hidden;
  color: #333333;
  font-size: 18px;
  font-weight: 500;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.share-popup__actions {
  display: flex;
  justify-content: center;
  gap: 62px;
  margin-top: 20px;

  .share-popup__icon {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
    border: 0;
    gap: 10px;
    background: transparent;
    color: #333333;
    font-size: 16px;
    font-weight: 400;
  }

  .share-popup__icon > span {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: #f4f4f4;
  }

  .app-svg-icon {
    color: #000000;
    font-size: 30px;
  }
}

:global(.invite-poster-popup--compact.van-popup--center) {
  top: calc(env(safe-area-inset-top) + 5%) !important;
  width: min(calc(var(--app-shell-width) - 32px), 290px) !important;
}

:global(.invite-poster-popup--compact .invite-poster) {
  height: 325px;
}

.share-popup--compact {
  padding-bottom: calc(14px + env(safe-area-inset-bottom));
}

.share-popup--compact .share-popup__header {
  padding: 15px 20px 12px;

  h3 {
    font-size: 19px;
  }
}

.share-popup--compact .share-popup__rows {
  gap: 10px;
  padding: 0 20px;
}

.share-popup--compact .share-popup__row {
  padding: 14px 14px 17px;
  border-radius: 11px;

  > span {
    font-size: 15px;
  }
}

.share-popup--compact .share-popup__value {
  font-size: 17px;
}

.share-popup--compact .share-popup__actions {
  gap: 56px;
  margin-top: 18px;

  button {
    gap: 8px;
    font-size: 15px;
  }

  button > span {
    width: 48px;
    height: 48px;
  }

  :deep(.van-icon) {
    font-size: 28px;
  }
}

:global(.invite-kyc-dialog-popup) {
  overflow: visible;
  border-radius: 16px;
  background: transparent;
}

.invite-kyc-dialog {
  position: relative;
  box-sizing: border-box;
  width: 300px;
  padding: 48px 16px 24px;
  border-radius: 16px;
  background: #ffffff;
  text-align: center;
  :deep(.van-icon__image) {
    width: 14px !important;
    height: 14px !important;
  }
}

.invite-kyc-dialog__icon {
  position: absolute;
  top: -23px;
  left: 50%;
  width: 53px;
  height: 53px;
  transform: translateX(-50%);

  :deep(.van-image__img) {
    object-fit: contain;
  }
}

.invite-kyc-dialog__close {
  position: absolute;
  top: 2px;
  right: 16px;
  border: 0;
}

.invite-kyc-dialog h2 {
  margin: 0;
  color: #090909;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
}

.invite-kyc-dialog p {
  margin: 20px 0 24px;
  color: #555555;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
}

.invite-kyc-dialog__actions {
  display: flex;
  gap: 10px;
}

.invite-kyc-dialog__actions button {
  flex: 1;
  height: 40px;
  padding: 0;
  border: 0;
  border-radius: 24px;
  font-size: 18px;
  font-weight: 500;
}

.invite-kyc-dialog__cancel {
  background: var(--wp-color-button-3);
  color: var(--wp-color-theme);
}

.invite-kyc-dialog__confirm {
  background: var(--wp-color-theme);
  color: #ffffff;
}

:global(.kyc-dialog-popup) {
  overflow: visible;
  border-radius: 12px;
  background: transparent;
}

.kyc-dialog {
  position: relative;
  box-sizing: border-box;
  width: 300px;
  padding: 34px 16px 20px;
  border-radius: 12px;
  background: #ffffff;
  text-align: center;
}

.kyc-dialog__icon {
  position: absolute;
  top: -25px;
  left: 50%;
  width: 50px;
  height: 50px;
  transform: translateX(-50%);
}

.kyc-dialog__close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 18px;
  height: 18px;
  padding: 0;
  border: 0;
  background: transparent;

  .app-image {
    width: 18px;
    height: 18px;
  }
}

.kyc-dialog h2 {
  margin: 0;
  color: #090909;
  font-size: 18px;
  font-weight: 700;
  line-height: 25px;
}

.kyc-dialog p {
  margin: 12px 0 16px;
  color: #444444;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
}

.kyc-dialog__actions {
  display: flex;
  gap: 10px;
}

.kyc-dialog__actions button {
  flex: 1;
  height: 40px;
  padding: 0;
  border: 0;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 400;
}

.kyc-dialog__cancel {
  background: var(--wp-color-button-3);
  color: var(--wp-color-theme);
}

.kyc-dialog__confirm {
  background: var(--wp-color-theme);
  color: #ffffff;
}
</style>
